import type { FC, MouseEventHandler, ReactNode } from 'react';
import { Link } from 'react-router-dom';

import { useThrottleClick } from 'hooks';
import { ButtonType } from 'types/button';

const hasProtocol = (link: string) => {
  const protocolRegex = /^(https?:\/\/)/i;

  return protocolRegex.test(link);
};

type DynamicTagButtonPropTypes = {
  href?: string;
  disabled?: boolean;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  className?: string;
  children: ReactNode;
  type?: ButtonType;
  id?: string;
};

const DynamicTagButton: FC<DynamicTagButtonPropTypes> = ({
  href,
  children,
  disabled,
  className,
  onClick,
  type,
  ...props
}) => {
  const handleClick = useThrottleClick({
    disabled,
    onClick,
  });

  if (href && hasProtocol(href)) {
    return (
      <a href={href} className={className} {...props}>
        {children}
      </a>
    );
  }

  if (href && !hasProtocol(href)) {
    return (
      <Link to={href} className={className} {...props}>
        {children}
      </Link>
    );
  }

  return (
    <button
      className={className}
      type={type === ButtonType.submit ? 'submit' : 'button'}
      disabled={disabled}
      onClick={handleClick}
      {...props}
    >
      {children}
    </button>
  );
};

export { DynamicTagButton };
